import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgDownloadService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    //Deprecated
    getListCarInfo(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/download";
        url += "/car/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     companyId:1
        //     ,dtgEid:"2288100534"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    //Deprecated
    getCountCarUsed(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/download";
        url += "/car/used/count";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     companyId:1
        //     ,dtgEid:"2288100534"
        //     ,searchDateFrom:"2019-04-06 00:00:00"
        //     ,searchDateTo:"2019-04-06 23:59:59"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    //Deprecated
    downloadFile(searchInfo):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/download";
        url += "/downloadFile";

        let header = new HttpHeaders({
            "Content-Type" : "application/json"      
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);
       
        return this.http.post<any>(url,bodyData,{ headers : header});
    }

    //Deprecated
    etasFileRequest(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/download";
        url += "/etas/file/request";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     companyId:1
        //     ,dtgEid:"2288100534"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    etasFileCreateHist(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/download";
        url += "/etas/file/create/hist";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    etasFileDown(searchInfo:any):Observable<Blob>{
        let url = this.getApiBaseUrl() + "/dtg/download";
        url += "/etas/file/down";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     companyId:1
        //     ,dtgEid:"2288100534"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post(url,bodyData,{ headers : header,responseType : "blob" });
    }

    //Deprecated
    etasFileDown2(fileName:string):Observable<any>{
        let url = this.getApiBaseUrl() + "/download";
        url += "/etas/file/down";
        url += "?fileName=";
        url += fileName;

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        return this.http.get(url,{ headers:header,responseType:"blob" });
    }

    //Deprecated
    etasFileCheck(fileName:string):Observable<any>{
        let url = this.getApiBaseUrl() + "/download";
        url += "/etas/file/check";
        url += "?fileName=";
        url += fileName;

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        return this.http.get(url,{ headers:header });
    }
}